"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getters = {
  sidebar: function sidebar(state) {
    return state.system.sidebar;
  },
  language: function language(state) {
    return state.system.language;
  },
  size: function size(state) {
    return state.system.size;
  },
  device: function device(state) {
    return state.system.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  ticket: function ticket(state) {
    return state.user.ticket;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  mobile: function mobile(state) {
    return state.user.mobile;
  },
  username: function username(state) {
    return state.user.username;
  },
  menu: function menu(state) {
    return state.user.menu;
  },
  role: function role(state) {
    return state.user.role;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  id: function id(state) {
    return state.user.id;
  },
  app_roles: function app_roles(state) {
    return state.user.app_roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  appList: function appList(state) {
    return state.app.appList;
  },
  appName: function appName(state) {
    return state.app.appName;
  },
  curPid: function curPid(state) {
    return state.app.curPid;
  },
  curPlatform: function curPlatform(state) {
    return state.app.curPlatform;
  }
};
var _default = getters;
exports.default = _default;